// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"844":"c7c08b7f","913":"acb27753"}[chunkId] + ".chunk.js";
};